



import { AnnouncementConstants } from '../constants/announcement-constants.js';
import AnnouncementService from '../services/Employee/announcement-service.js';
 // import { message } from 'antd';

 //制度公告
// export function fetchAnnouncementList(gets = {page: 1}) {
//     return dispatch => {
//         AnnouncementService.selectAnnouncement(gets, res => {
//             console.log(res.data.Object);
//             dispatch({
//                 type: Announcement.ActionTypes.FETCHANNOUNCEMENTLISTSSUCCESS,
//                 payload: {
//                     announcementListPage: res.data.Page,
//                     announcementListTotalPage: res.data.Total,
//                     announcementListData: res.data.Object.Data,
//                     announcementListDataStatus: "loaded"
//                 }
//             });
//         }, err => {});
//     }
// }

function changeAnnouncementAction (filters = {}, status = "loading", counter = 1) {
    return {
        type: AnnouncementConstants.ActionTypes.CHANGEANNOUNCEMENT,
        payload: {
            filters: filters,
            status: status,
            counter: counter
        }
    }
}
export function changeAnnouncement (filters = {}, status = "loading", counter = 1) {
    return dispatch => dispatch(changeAnnouncementAction(filters, status, counter));
}
export function selectAnnouncement (gets, callback) {
    let apiLoadStatus = false;
    return dispatch => {
        AnnouncementService.selectAnnouncement(gets, res => {
            // console.log(res.data);
            apiLoadStatus = true;
            if (res.data.Success) {
                dispatch({
                    type: AnnouncementConstants.ActionTypes.SELECTANNOUNCEMENT,
                    payload: {
                        data: res.data.Object,
                        status: "loaded"
                    }
                });
            }else{
                dispatch(changeAnnouncementAction({}, "error", 0));
            }
        }, err => {
            apiLoadStatus = true;
            dispatch(changeAnnouncementAction({}, "error", 0))
        })
        let timeoutIndex = setTimeout(() => {
            clearTimeout(timeoutIndex);
            if (!apiLoadStatus) {
                dispatch(changeAnnouncementAction({}, "loading", 0))
            }
        }, 100);
    }
}
export function updateAnnouncement (puts, index, callback) {
    return dispatch => AnnouncementService.updateAnnouncement(puts, res => {
        if ("function" === typeof callback) {
            callback(res);
        }
        if (res.data.Success) {
            dispatch({
                type: AnnouncementConstants.ActionTypes.UPDATEANNOUNCEMENT,
                payload: {
                    data: puts,
                    index: index
                }
            })
        }
    })
}


// WEBPACK FOOTER //
// ./src/actions/announcement-actions.js